// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAnalytics, isSupported } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {

  apiKey: "AIzaSyCdY51aKKJMa7qPe6q_XhzJBnPggJxYF1Y",

  authDomain: "fighn-40bf9.firebaseapp.com",

  databaseURL: "https://fighn-40bf9-default-rtdb.firebaseio.com",

  projectId: "fighn-40bf9",

  storageBucket: "fighn-40bf9.firebasestorage.app",

  messagingSenderId: "897622446057",

  appId: "1:897622446057:web:b4064fc64bb805f2dc8578",

  measurementId: "G-LY9DG82H01"

};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

// Conditionally initialize Firebase Analytics
if (typeof window !== 'undefined') {
  // This block will only run in the browser
  isSupported().then(supported => {
    if (supported) {
      getAnalytics(app);
    }
  });
}

export default database;
